$(document).ready(function () {
    $("#carselector-default-submit-tyres").on('click', storeTyreVehicleData);
    $("#carselector-default-submit-cw").on('click', storeTyreVehicleData);
    $("#carselector-default-submit").on('click', storeTyreVehicleData);
    $("#car_reset").on('click', removeTyreVehicleData);
    $("#car_change").on('click', function () {
        $("#selected_car_info").hide();
        $("#car_selector_form").show();
        if ($(".preselectedCar-ab-testing").length > 0) {
            $('#carselector-default-manufacturer').val("");
            $(".car-selector-field").hide();
        }
    });
    $("#car_change_cancel").on('click', function () {
        $("#selected_car_info").show();
        $("#car_selector_form").hide();
        if ($(".preselectedCar-ab-testing").length > 0) {
            $('#carselector-default-manufacturer').val("");
            $(".car-selector-field").hide();
        }
    });
});

function storeTyreVehicleData() {
    var data;
    data = {
        id: $('input[name=vehicleId]').val(),
        manufacturer: $('input[name=vehicleManufacturer]').val(),
        model: $('input[name=vehicleModel]').val(),
        engine: $('input[name=vehicleEngineType]').val(),
        specification: $('input[name=vehicleSpecification]').val(),
        width: $('#searchByBrandForm input[name=width]').val() ? $('#searchByBrandForm input[name=width]').val() : "",
        tyreProfile: $('#searchByBrandForm input[name=profile]').val() ? $('#searchByBrandForm input[name=profile]').val() : "",
        size: $('#searchByBrandForm input[name=size]').val() ? $('#searchByBrandForm input[name=size]').val() : "",
        loadIndex: $('#searchByBrandForm input[name=loadIndex]').val() ? $('#searchByBrandForm input[name=loadIndex]').val() : "",
        speedRating: $('#searchByBrandForm input[name=speedRating]').val() ? $('#searchByBrandForm input[name=speedRating]').val() : ""
    };
    window.localStorage.setItem('tyreVehicleData', JSON.stringify(data));
}

function removeTyreVehicleData() {
    if (window.localStorage.getItem('tyreVehicleData')) {
        window.localStorage.removeItem('tyreVehicleData');
    }
    if (window.localStorage.getItem('enablePreselectedCarAbTesting')) {
        $.ajax({
            type: 'GET',
            url: "/resetPreselectedCar",
            success: function () {
                window.location.href = createUrlAfterResetCar();
            }
        });
    } else {
        window.location.href = createUrlAfterResetCar();
    }

}

function createUrlAfterResetCar() {
    var url = "/search?priceCategory=recommended";
    var season = $("#filterForm #season").val();
    if (season) {
        url = url + "&season=" + season;
    }
    var vehicleType = $("#filterForm input[name=vehicleTypes]").val();
    if (vehicleType) {
        url = url + "&vehicleTypes=" + vehicleType;
    }

    return url;
}

function getVehicleData() {
    var vehicleData;
    var selectedCarInfoBlock = $("#selected_car_info");
    if (window.localStorage.getItem('tyreVehicleData')) {
        vehicleData = JSON.parse(window.localStorage.getItem('tyreVehicleData'));
        if (!vehicleData.width && !vehicleData.tyreProfile && !vehicleData.size ) {
            selectedCarInfoBlock.hide();
            return;
        }
        var vehicleTitle = vehicleData.manufacturer + " " + vehicleData.model + " " + vehicleData.engine;
        var vehicleImageElement = $("#selected_car_img");
        vehicleImageElement.attr('src', 'https://image.delti.com/simg/Logos/' + vehicleData.manufacturer.replace(" ", "") + '.png');
        vehicleImageElement.attr('alt', vehicleTitle);
        $("#selected_car_title").html(vehicleTitle);
        $("#selected_car_specification").html("-" + vehicleData.specification);
        var carDimensions = "";

        if (vehicleData.width) {
            carDimensions += "-" + vehicleData.width;
        }
        if (vehicleData.tyreProfile) {
            carDimensions += "/" + vehicleData.tyreProfile;
        }
        if (vehicleData.size) {
            carDimensions += " R" + vehicleData.size;
        }
        carDimensions += " " + vehicleData.loadIndex + vehicleData.speedRating;

        $("#selected_car_profile").html(carDimensions);
        $("#car_selector_form").hide();
        selectedCarInfoBlock.show();
    } else {
        selectedCarInfoBlock.hide();
    }
}
